import {Component, Input, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {NgStyle} from '@angular/common';
import {activateStripe} from '../../common/stripe-utils';


@Component({
    selector: 'connect-with-stripe',
    templateUrl: './connect-with-stripe.component.html',
    styleUrls: ['./connect-with-stripe.component.css'],
    standalone: true,
    imports: [NgStyle]
})
export class ConnectWithStripeComponent implements OnInit {

  @Input()
  message:string;

  @Input()
  minHeight = "330px";

  @Input()
  goToAfterConnection = "courses";

  constructor() {

  }

  ngOnInit() {

  }


  connectWithStripe() {
      return activateStripe(this.goToAfterConnection);
  }


}
